// auto-generated by Typewriter template _models.tst from PortCall.Pilots.EndPoints\Api\LineHandlingCompany\ApiLineHandlingCompany.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { PilotAgency, PilotAgencyData, PilotAgencyOptions } from 'data/models/PilotAgency';
import { PilotJobOrder, PilotJobOrderData, PilotJobOrderOptions } from 'data/models/PilotJobOrder';

// LineHandlingCompanyData is the class that LineHandlingCompany serializes to/from
export interface LineHandlingCompanyData {
    Id : number;
    Url : string | null;
	
    PilotAgency : PilotAgencyData | null;
    PilotAgencyId : number;
    PilotJobOrders : PilotJobOrderData[] | null;
	
    Active : boolean;
    Code : string;
    Name : string;
}

// LineHandlingCompanyOptions is the class which may be passed to the LineHandlingCompany constructor to define optional initial data values
export interface LineHandlingCompanyOptions {
    Id : number;
    Url? : string | null;
	
    PilotAgency? : PilotAgencyOptions | null;
    PilotAgencyId? : number;
    PilotJobOrders? : PilotJobOrderOptions[] | null;
	
    Active? : boolean;
    Code? : string;
    Name? : string;
}

export class LineHandlingCompany {
    public Id : DataSignal<number>;
    public Url : DataSignal<string | null>;
	
    public PilotAgency : DataSignal<PilotAgency | null>;
    public PilotAgencyId : DataSignal<number>;
    public PilotJobOrders : SDataArray<PilotJobOrder>;
	
    public Active : DataSignal<boolean>;
    public Code : DataSignal<string>;
    public Name : DataSignal<string>;

    constructor();
    constructor(data : LineHandlingCompanyOptions);
    constructor(data: LineHandlingCompanyOptions | null = null) {
        this.Id = jsonableObservable(S.value<number>(data && data.Id !== undefined ? data.Id : 0));
        this.Url = jsonableObservable(S.value<string | null>(data && data.Url !== undefined ? data.Url : null));
	    
        this.PilotAgency = S.value<PilotAgency | null>(null);
        this.PilotAgencyId = jsonableObservable(S.value<number>(data && data.PilotAgencyId !== undefined ? data.PilotAgencyId : 0));
        this.PilotJobOrders = SArray<PilotJobOrder>([]);
	    
        this.Active = jsonableObservable(S.value<boolean>(data && data.Active !== undefined ? data.Active : false));
        this.Code = jsonableObservable(S.value<string>(data && data.Code !== undefined ? data.Code : ''));
        this.Name = jsonableObservable(S.value<string>(data && data.Name !== undefined ? data.Name : ''));
    }

    static key(obj : LineHandlingCompany) {
        return obj.Id();
    }
    
    static dataKey(obj : LineHandlingCompanyOptions) {
        return obj.Id;
    }

    static update(obj : LineHandlingCompany, data : LineHandlingCompanyOptions) {
        S.freeze(() => {
            if (data.Id !== undefined) obj.Id(data.Id);
            if (data.Url !== undefined) obj.Url(data.Url);
	        
            if (data.PilotAgencyId !== undefined) obj.PilotAgencyId(data.PilotAgencyId);
	        
            if (data.Active !== undefined) obj.Active(data.Active);
            if (data.Code !== undefined) obj.Code(data.Code);
            if (data.Name !== undefined) obj.Name(data.Name);
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/LineHandlingCompany.ts